import { IblocksRecreateJSONToSend } from "@/components/widgets/Creation/helper/creationInterfaces";
import { generateNotDealtToastTradeCreation } from "@/lib/notifications/toastNotificationHelpers";
import { fetchRequestWrapper } from "@/lib/utilities";
import { NewValueParams } from "ag-grid-community";
import { toast } from "react-toastify";

export async function saveCreationBlockValuesToDatabase(
  params: NewValueParams,
  getAccessTokenSilently: Function,
) {
  const blockIdToSave = params.data.id;
  const effectiveDateToSave = params.data.effectiveDate;
  const newIssueToSave = params.data.newIssue;
  const statusToSave = params.data.status;

  if (
    params.newValue == params.oldValue &&
    params.colDef.cellDataType == "dateString"
  ) {
    toast.error("Enter a date, field cannot be empty");
    return;
  }

  const objToSend = {
    id: blockIdToSave,
    effectiveDate: effectiveDateToSave,
    newIssue: newIssueToSave,
    status: statusToSave,
  };

  const saveBlockResponse = await fetchRequestWrapper(
    { url: "/Blocks/Unassigned", method: "PUT", objToSend: objToSend },
    getAccessTokenSilently,
  );

  // No flash here: the save raises a BlockUpdated event, and updateBlockAction flashes the row for everyone
  // in the customer, this user included
  if (saveBlockResponse) {
    if (params.newValue == params.data.effectiveDate) {
      toast("Settlement Date updated");
    } else if (params.newValue == params.data.newIssue) {
      toast("New Issue Flag updated");
    } else {
      toast("Block changes saved");
    }
  }
}

export async function updateBlockStatusFromContextActions({
  blockIdPassed,
  statusPassed,
  newIssue,
  effectiveDate,
  getAccessTokenSilently,
}: {
  blockIdPassed: number;
  statusPassed: "Not Dealt" | "Unassigned" | "Cancelled";
  newIssue: boolean;
  effectiveDate: Date;
  getAccessTokenSilently: Function;
}) {
  const objToSend = {
    id: blockIdPassed,
    effectiveDate: effectiveDate,
    newIssue: newIssue,
    status: statusPassed,
  };

  const response = await fetchRequestWrapper(
    { url: "/Blocks/Unassigned", method: "PUT", objToSend: objToSend },
    getAccessTokenSilently,
  );

  if (response) {
    generateNotDealtToastTradeCreation(statusPassed)
  }
}

export async function deleteBlockFromContextActions({
  blockIdPassed,
  getAccessTokenSilently,
}: {
  blockIdPassed: number;
  getAccessTokenSilently: Function;
}) {
  await fetchRequestWrapper(
    { url: `/Blocks/${blockIdPassed}`, method: "DELETE" },
    getAccessTokenSilently,
  );
}

export async function splitBlocksSERVICE(
  blocksToSend: IblocksRecreateJSONToSend,
  getAccessTokenSilently: Function,
) {
  const recreateBlocksResponse = await fetchRequestWrapper(
    {
      url: `/Blocks/Recreate`,
      method: "POST",
      objToSend: blocksToSend,
    },
    getAccessTokenSilently,
  );

  return recreateBlocksResponse;
}
